import { required, optional, obj, array } from 'AppReact/schema';
import { part } from './part';

export const fullOrder = {
  allow_sms: required('boolean'),
  category: obj({
    id: optional('integer'),
    parent_id: optional('integer'),
    parent_name: optional('string'),
    category: optional('string'),
    attachment_url: optional('string')
  }),
  entry_allowed: optional('boolean'),
  scheduled_for: optional('string'),
  has_pet: optional('boolean'),
  id: required('integer'),
  inserted_at: optional('string'),
  level: optional('string'),
  property: obj({
    id: required('integer'),
    name: required('string'),
    lat: optional('string'),
    lng: optional('string')
  }),
  property_id: required('integer'),
  status: optional('string'),
  tenant: obj({
    email: optional('string'),
    first_name: optional('string'),
    id: optional('integer'),
    last_name: optional('string'),
    tenancy_id: optional('integer'),
    alarm_code: optional('string'),
    phone: optional('string')
  }),
  ticket: optional('string'),
  unit: obj({
    area: optional('integer'),
    floor_plan: optional('string'),
    id: optional('integer'),
    number: optional('string')
  }),
  order_events: optional('array'),
  assignments: optional('array'),
  created_by: optional('string'),
  parts: array(obj(part)),
  inspection_id: optional('integer'),
  inspection_template: optional('string'),
  post_error: optional('string'),
  not_posted: optional('boolean'),
  needs_sync: optional('boolean')
};
